<template>
    <div class="webhook-data-item">
        <TiptapEditor placeholder="Data-Key" :show-attributes="false" v-model="clone.key" automation-mode />
        <TiptapEditor placeholder="Value" :show-attributes="true" v-model="clone.value" automation-mode />
        <SupsisButton small danger @click="deleteItem"><i class="material-icons">delete</i></SupsisButton>
    </div>
</template>
<script>
import Vue from "vue";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import StringUtils from "../../../../../../../utils/StringUtils";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import _ from "lodash";

export default Vue.extend({
    name: "DataItem",
    components: { SupsisButton, TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            key: null,
            value: null,
        };
        return {
            clone,
            hashCode: StringUtils.hashCodeObj(clone),
        };
    },
    methods: {
        deleteItem() {
            this.$emit("delete");
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.hashCode = StringUtils.hashCodeObj(newValue);
                this.$emit("input", newValue);
            },
        },
    },
});
</script>

<style scoped lang="scss">
.webhook-data-item {
    display: flex;
    flex-direction: row;
    gap: 10px;
}
</style>
